// @flow

// Vendors
import React, { useState } from 'react';

// Components
import { Form, FormField, FormSubmit, Notice } from '..';

// Requests
import { loginRequest } from '../../requests';

// Helpers
import { geURLParameters } from '../../../lib/helpers';

const LoginForm = () => {
  const [success, setSuccess] = useState('');
  const { redirect } = geURLParameters();

  const initialValues = {
    email: '',
    password: '',
    remember: false
  };

  const handleSubmit = ({
    values,
    errors,
    setValues,
    setErrors,
    setSubmitting
  }) => {
    setSubmitting(true);

    loginRequest(values)
      .then(({ data }) => {
        setSuccess('Login successful. Redirecting...');

        setTimeout(() => {
          window.location = redirect
            ? decodeURIComponent(redirect)
            : '/resource-center';
        }, 1000);
      })
      .catch(({ data }) => {
        setSubmitting(false);
        if (data.errors) setErrors(data.errors);
      });
  };

  return (
    <Form
      className="card u--squash"
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={({ values, errors, isSubmitting, setError, handleChange }) => (
        <>
          <div className="card__body">
            <FormField
              name="email"
              label="Email Address"
              onChange={handleChange}
              value={values.email}
              error={errors.email}
              disabled={isSubmitting}
            />
            <FormField
              name="password"
              label="Password"
              type="password"
              helpText={
                <>
                  <a href="/resource-center/forgot-password">
                    Forgot your password?
                  </a>
                </>
              }
              onChange={handleChange}
              value={values.password}
              error={errors.password}
              disabled={isSubmitting}
            />
            <FormField
              name="remember"
              label="Remember Me"
              type="checkbox"
              onChange={handleChange}
              checked={values.acceptUserAgreement}
              error={errors.remember}
              disabled={isSubmitting}
            />
            <FormSubmit
              loading={isSubmitting}
              disabled={isSubmitting}
              disabledLabel={
                isSubmitting && !success ? 'Submitting...' : 'Submit'
              }
            />
            {errors.formError && (
              <Notice
                type="danger"
                message={errors.formError}
                dismiss={() => setError('formError', '')}
              />
            )}
            {success && <Notice type="success" message={success} />}
          </div>

          <div className="card__footer">
            <p>
              Need an account?{' '}
              <a href="/resource-center/register">Register now</a>.
            </p>
          </div>
        </>
      )}
    />
  );
};

export default LoginForm;
